// extracted by mini-css-extract-plugin
export default {"footer":"imsthMoQZvG7PlT5PVbA","bounce":"PdYduX2OswJiMCtrd59B"};